var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7947 2.48975C14.9028 2.48975 18.264 5.85092 18.264 9.95901C18.264 14.0671 14.9028 17.4283 10.7947 17.4283C6.68661 17.4283 3.32544 14.0671 3.32544 9.95901C3.32544 5.85092 6.68661 2.48975 10.7947 2.48975ZM10.7947 1.24487C6.00193 1.24487 2.08057 5.16624 2.08057 9.95901C2.08057 14.7518 6.00193 18.6732 10.7947 18.6732C15.5875 18.6732 19.5088 14.7518 19.5088 9.95901C19.5088 5.16624 15.5875 1.24487 10.7947 1.24487Z",
    fill: "#FFC200"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7744 9.33659H11.4174V4.97952H10.1725V9.33659H5.81543V10.5815H10.1725V14.9385H11.4174V10.5815H15.7744V9.33659Z",
    fill: "#FFC200"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddIcon);
export default __webpack_public_path__ + "static/media/add-icon.81a510489dcf6f0d5c64f07b8a5755f3.svg";
export { ForwardRef as ReactComponent };